import React,{Component} from "react";

// reactstrap components
import {
  Col,
  Row,
  Progress,
  Button
} from "reactstrap";
import SpeechRecognition from 'react-speech-recognition';
import Dictaphone from "./Dictaphone.jsx";
import Sound from 'react-sound';
// import getBlobDuration from 'get-blob-duration';
import { getBlobURL, getFile, getDuration } from "util/blobUtils.js";
import {base,s3base} from "api.js";
import NoMicrophone from "views/NoMicrophone.jsx";
import MicRecorder from 'mic-recorder-to-mp3';
import "components/custom.css";
import SpeechToText from "./New/SpeechToText.jsx";
let Mp3Recorder = new MicRecorder({ bitRate: 128 });

class DescribeImage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isRecording: false,
      blobURL: '',
      isBlocked: false,
      question:"",
      secondCount:25,
      recordCount:0,
      recordId:1,
      intervalId:0,
      duration:0,
      questionId:"",
      reset:false,
      trans:'',
      correctFlag:true,
      soundStatus:false,
      file:'',
      imageLoaded:true,
      saveTranscript: false,
      isProcessing: false
    };
  }

  componentDidMount() {
    console.log("I am DescribeIAmge from the Question")
    if (!this.props.answer) {
     var intervalId = setInterval(this.timer, 1000);
       this.setState({intervalId: intervalId});
    }
    navigator.getUserMedia({ audio: true },
      () => {
        this.setState({ isBlocked: false });
      },
      () => {
        this.setState({ isBlocked: true })
      },
    );
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data) {
        if ((state.questionId && state.questionId !== props.data.id) || props.restart) {
            clearInterval(state.intervalId);
            clearInterval(state.recordId);
            
            return {recordCount:0,isRecording:false,secondCount:25,questionId: props.data.id,blobURL:'',reset:true,imageLoaded:false,trans:'',duration:0,isProcessing: false};
        }else{
            if (!state.questionId) {
                return {questionId: props.data.id,imageLoaded:false};
            }
        }
        
        }
        
    
  }

  revokeBlobURL = () => {
    const { blobURL } = this.state;
    if (blobURL) {
      try {
        // Only revoke if URL exists and is a proper blob URL
        if (blobURL.startsWith("blob:")) {
        URL.revokeObjectURL(blobURL);
          console.log("🧹 Revoked blob URL instantly:", blobURL);
        }
      } catch (err) {
        console.error("⚠️ Failed to revoke blob URL:", err);
      } finally {
        // Clear from state to prevent reuse
          this.setState({ blobURL: '' });
      }
    }
  };

  start = () => {
    this.setState({ soundStatus: true});
  };

  handleSongFinishedPlaying = () =>{
    if (this.state.isBlocked) {
      console.log('Permission Denied');
    } else {
      SpeechRecognition.startListening({ continuous: true, language: 'en-GB' })
      Mp3Recorder = new MicRecorder({ bitRate: 128 });
      Mp3Recorder
        .start()
        .then(() => {
          this.setState({ isRecording: true,blobURL:'',soundStatus:false});
        }).catch((e) => console.error(e));
    }
  }

  setTrans = (a)=>{
    if (this.state.trans != a) {
      this.setState({trans:a})  
    }
    
  }

  stop = () => {
    if (!this.state.isBlocked && this.state.isRecording) {
      Mp3Recorder
        .stop()
        .getMp3()
        .then(async ([buffer, blob]) => {
          // const blobURL = URL.createObjectURL(blob);
          // let duration = await getBlobDuration(blobURL);
          // let file = new File([blob], 'noname1'+this.state.questionId+'.mp3', { type: blob.type });
          this.revokeBlobURL();
          if(blob && blob.size > 0){
            const duration = await getDuration(blob);
            const file = await getFile(blob, buffer,'noname1'+this.state.questionId+'.mp3');
            const blobURL = await getBlobURL(blob, file);
            this.setState({ 
              blobURL, 
              isRecording: false,
              recordCount:100,
              file:file,
              duration
            });
          this.props.submit({'data': file,'audio_text':this.state.trans, duration: duration },true);
          }else{
            this.setState({ 
              blobURL: '',
              isRecording: false,
              recordCount: 100,
              file: null
            });

          this.props.submit({data: null,audio_text:this.state.trans, duration: 0 },true);
          }
          SpeechRecognition.stopListening();
          // this.props.submit({'data': file,'audio_text':this.state.trans,duration: duration },true);
          //this.props.submit({'data':file },true)
          this.props.showResult();
        }).catch((e) => console.log(e));
    }
  };

  stopTest = async () => {
    if (this.state.isProcessing) return;

    if (!this.state.isBlocked && this.state.isRecording) {
      this.setState({ isProcessing: true });
      Mp3Recorder
        .stop()
        .getMp3()
        .then( async ([buffer, blob]) => {
          // const blobURL = URL.createObjectURL(blob);
          // let duration = await getBlobDuration(blobURL);
          // let file = new File([blob], 'noname1.mp3', { type: blob.type });
          // this.setState({ isRecording: false,recordCount:100 });
          this.revokeBlobURL();
          if(blob && blob.size > 0){
            const duration = await getDuration(blob);
             const file = await getFile(blob, buffer,'noname1.mp3');
            const blobURL = await getBlobURL(blob, file);            
            this.setState({ 
              isRecording: false,
              recordCount: 100,
              duration,
              file,
              blobURL,
              isProcessing: false,
            });
            console.log("inside if file,duration,audio",file,duration,this.state.trans);
            SpeechRecognition.stopListening();
          }else{
            this.setState({ 
              duration: 0,
              file: null,
              blobURL: '',
              isRecording: false,recordCount:100,isProcessing: false });
          }
          SpeechRecognition.stopListening();
          //this.props.submit({'data':file },true)
          //this.props.showResult();
          // this.props.nextQuestion({'data': file,'audio_text':this.state.trans, duration:duration });
        }).catch((e) => console.log(e));
    }else{
      console.log("inside else file,duration,audio",this.state.file,this.state.duration,this.state.trans);
      if(!this.state.isProcessing){
        this.setState({ isProcessing: true });
        this.props.nextQuestion({data: this.state.file,audio_text:this.state.trans, duration: this.state.duration });
        this.setState({ isProcessing: false });
      }
      //this.props.submit({'data': '' },true);
    }
  };

   setTranscript = (transcript) => {
    this.setState({
      trans: transcript,
      saveTranscript: false
    }, () => {
      // this code was in stop() earlier.
      // after replace <Dictaphone /> with <SpeechToText />,  this code placed here.
      // to get transcript effectively.
       console.log("inside transcript file,duration,audio",this.state.file,this.state.duration,this.state.trans);
      const data_to_send = {
        data: this.state.file,
        audio_text: transcript,
        duration: this.state.duration
      };
      console.log("data_to_send---",data_to_send);
      
      if (this.props.testMode) {
        this.props.nextQuestion(data_to_send);
      } else {
        this.props.submit(data_to_send, true);
        this.props.showResult();
      }
    });
  }
  updateCorrect = () =>{
     this.props.submit({'data':'', 'audio_text':'','duration':this.state.duration});
     this.setState({correctFlag:false})
  }

  skip = () => {
    clearInterval(this.state.intervalId);
    this.start();
    var recordId = setInterval(this.timerRecord, 1000);
    this.setState({recordId: recordId,secondCount:0});
  };

    timer = () => {
        if (this.state.secondCount === 1) {
            clearInterval(this.state.intervalId);
            this.start();
            var recordId = setInterval(this.timerRecord, 1000);
            this.setState({recordId: recordId});
        }
        this.setState({ secondCount: this.state.secondCount -1 });
    }



    timerRecord = () => {
        if (this.state.recordCount === 40) {
            clearInterval(this.state.recordId);
            this.stop();
        }
        this.setState({ recordCount: this.state.recordCount + 1 });	
    }

    componentWillUnmount = () => {
        clearInterval(this.state.intervalId);
    this.revokeBlobURL();
    }

  handleImageLoaded =() =>{
    this.setState({ imageLoaded: true });
  }
  
  componentDidUpdate(prevProps, prevState) {
    // && this.props.stopRecording !== prevProps.stopRecording
    if (this.props.stopRecording) {
      this.stopTest();
    }
  }
  
  render() {
    let question ="";
    // if (!this.state.imageLoaded) {
    //   const img = new Image();
    //   img.src = s3base + this.props.data.media_link;
    //   if (img.complete) {
    //     var intervalId = setInterval(this.timer, 1000);
    //     this.setState({intervalId: intervalId,reset:false,imageLoaded:true});
          
    //   }
    // }
    if (this.props.restart) {
      this.props.restartQue();
    }
    // if (this.props.stopRecording) {
    //   this.stopTest();      
    // }
    if (this.props.data) {
        question = this.props.data.question;
      if (this.state.correctFlag) {
        this.updateCorrect();
      }
    }
    if (this.state.reset) {
        /*var intervalId = setInterval(this.timer, 1000);
        this.setState({intervalId: intervalId,reset:false});*/
    }
    if (this.state.isBlocked) {
      return (<NoMicrophone />);
    }
    
    return (
      <>
        {/* <Dictaphone setTrans={this.setTrans} status={this.state.reset || this.state.isRecording} /> */}
        <SpeechToText
          saveTranscript={this.state.saveTranscript}
          setTranscript={this.setTranscript}/>
        <Col xs={12}>
            <h4 className="infoText"></h4>
        </Col>
        <Col xs={12}>
          <Row>
            <Col lg={6}>
              {/*{!this.state.imageLoaded && <div style={{margin:'145px'}}>Loading...</div>}
              {this.state.imageLoaded && this.props.data && <img alt="media-link" width="500" onLoad={this.handleImageLoaded} src={s3base + this.props.data.media_link} />}*/}
              <img
                alt="media-link"
                width="500"
                onLoad={this.handleImageLoaded}
                src={`data:image/png;base64, ${this.props.data.image}`}
              />  
            </Col>
            <div className="col-lg-6 p-0 text-center">
                  {!this.props.resultMode && 
                <div className="audio-box">
                  <h4>Recorded Answer</h4>
                  <p><strong>Current status:</strong></p>
                  <p>
                    {/* {this.state.blobURL === '' && this.state.isRecording ? "Recording started" : `Recording starts in ${this.state.secondCount} seconds`} */}
                    <p>
  {this.state.isRecording 
    ? "Recording started" 
    : this.state.blobURL 
      ? "Recording Finished" 
      : `Recording starts in ${this.state.secondCount} seconds`
  }
</p>

                  </p>
                  {!this.props.testMode && this.state.blobURL === '' && !this.state.isRecording && 
                    <div className='stop-btn'>
                      <Button color="success" onClick={this.skip} size="sm">Skip</Button>
                    </div>
                  }
                  <hr></hr>
                  {/*this.state.isRecording && "Recording Time : "+this.state.recordCount*/}
                  {!this.props.testMode && this.state.isRecording && 
                    <div className='stop-btn'>
                      <Button color="success" onClick={this.stop} size="sm">Stop</Button>
                    </div>
                  }
                  <hr></hr>
                  <Progress color="info" value={(this.state.recordCount*2.5)} />
                  <div className="audo-line"><span className="progress-bar-fill-Read intro"></span></div>
                </div>
              }
                </div>
          </Row>
          
          <Col xs={12}>
            {this.state.blobURL && !this.props.testMode && 
              <audio src={this.state.blobURL} controls="controls" />
            }
          </Col>
        </Col> 
        
        <Col xs={12}>
          <h5>{question}</h5>
        </Col>

        {!this.props.resultMode && this.state.soundStatus && 
          <Sound url={`${s3base}/ptedata/ptemedia/beep.mp3`} playStatus={Sound.status.PLAYING} onFinishedPlaying={this.handleSongFinishedPlaying} />
        }
      </>
    );
  }
}
export default DescribeImage;